import type { KanbanComment } from '@entities/kanban-comment'

import { useKanbanCommentsStore } from '@entities/kanban-comment'
import { useCommonStore } from '@shared/model'
import { useAdminRoutes } from '@shared/lib/routes'

interface UpdateCommentResponse {
  stage_comment: KanbanComment
}

interface UpdateCommentApiOptions {
  tutorId: string | number
  commentId: string | number
  comment: string
  onStart?: () => void
  onSuccess?: (data: KanbanComment) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useUpdateCommentApi = async (options: UpdateCommentApiOptions): Promise<KanbanComment | null> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutor-kanban.comments.update', {
    tutor_id: options.tutorId,
    comment_id: options.commentId,
  })

  const kanbanCommentsStore = useKanbanCommentsStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.patch(url!, { comment: options.comment })
    const response: UpdateCommentResponse = data.data

    kanbanCommentsStore.updateComment(response.stage_comment)
    commonStore.setLoading(false)

    options.onSuccess?.(response.stage_comment)

    return response.stage_comment
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options.onError?.(err)

    return null
  } finally {
    options.onFinish?.()
  }
}